/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfAffiliateSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateAffiliateCommand, type CreateAffiliateCommand, type PaginatedListOfAffiliateSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ExportRequestBuilderRequestsMetadata, type ExportRequestBuilder } from './exportEscaped/index.js';
// @ts-ignore
import { AffiliatesItemRequestBuilderNavigationMetadata, AffiliatesItemRequestBuilderRequestsMetadata, type AffiliatesItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /affiliates
 */
export interface AffiliatesRequestBuilder extends BaseRequestBuilder<AffiliatesRequestBuilder> {
    /**
     * The export property
     */
    get exportEscaped(): ExportRequestBuilder;
    /**
     * Gets an item from the ApiSdk.affiliates.item collection
     * @param id Unique identifier of the item
     * @returns {AffiliatesItemRequestBuilder}
     */
     byId(id: Guid) : AffiliatesItemRequestBuilder;
    /**
     * GetAffiliates
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfAffiliateSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<AffiliatesRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfAffiliateSummary | undefined>;
    /**
     * CreateAffiliate
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateAffiliateCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetAffiliates
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<AffiliatesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateAffiliate
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateAffiliateCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetAffiliates
 */
export interface AffiliatesRequestBuilderGetQueryParameters {
    criteria?: string;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const AffiliatesRequestBuilderUriTemplate = "{+baseurl}/affiliates{?Criteria*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const AffiliatesRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AffiliatesRequestBuilderNavigationMetadata: Record<Exclude<keyof AffiliatesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: AffiliatesItemRequestBuilderRequestsMetadata,
        navigationMetadata: AffiliatesItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    exportEscaped: {
        requestsMetadata: ExportRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AffiliatesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AffiliatesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfAffiliateSummaryFromDiscriminatorValue,
        queryParametersMapper: AffiliatesRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: AffiliatesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateAffiliateCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
